module.exports = __webpack_public_path__ + "media/images/green_light-fa9010be7c83aafd08b38bd7b027e41a.jpg";